/** Insert or move a goals question to match `goalQuestions` order from the API/DB. */
export const insertGoalQuestionInOrder = (visibleQuestions, question, goalQuestions) => {
  if (!question) return visibleQuestions;

  const schemaIndex = goalQuestions.findIndex((q) => q.key === question.key);
  const without = visibleQuestions.filter((q) => q.key !== question.key);

  if (schemaIndex === -1) {
    return [...without, question];
  }

  let insertAt = without.length;
  for (let i = 0; i < without.length; i++) {
    const qSchemaIndex = goalQuestions.findIndex((q) => q.key === without[i].key);
    if (qSchemaIndex !== -1 && qSchemaIndex > schemaIndex) {
      insertAt = i;
      break;
    }
  }

  const next = [...without];
  next.splice(insertAt, 0, question);
  return next;
};

export const upsertGoalQuestionInOrder = (
  visibleQuestions,
  question,
  goalQuestions,
  value,
) => {
  return insertGoalQuestionInOrder(
    visibleQuestions,
    { ...question, value },
    goalQuestions,
  );
};
